var _defs, _rect, _rect2, _line, _line2, _line3, _rect3, _line4, _line5, _line6, _line7, _polyline, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContextTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7C3AED"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#ct-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 56,
    width: 44,
    height: 48,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.96
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 68,
    x2: 54,
    y2: 68,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 78,
    x2: 46,
    y2: 78,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 88,
    x2: 50,
    y2: 88,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 56,
    width: 44,
    height: 48,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.96
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 68,
    x2: 134,
    y2: 68,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 78,
    x2: 126,
    y2: 78,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 88,
    x2: 130,
    y2: 88,
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 80,
    x2: 92,
    y2: 80,
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "86,74 92,80 86,86",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 38,
    r: 2.5,
    fill: "#ffffff",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 122,
    r: 2,
    fill: "#ffffff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextTransfer);
export default __webpack_public_path__ + "static/media/ContextTransfer.f422cf08db5dcb2817ea1faf8f67cc5d.svg";
export { ForwardRef as ReactComponent };